// 返修记录
const repairRecord = [
  {
    path: '/pmp-record',
    name: 'pmpRecordPage',
    meta: { tag: '返修工单' },
    component: () => import('@/pages/PmpRecordPage')
  },
  {
    path: '/pmp-record/:id',
    name: 'pmpRecordDetail',
    meta: { tag: '返修记录详情' },
    component: () => import(`@/pages/PmpRecordPage/detail`)
  },
  {
    path: '/erp-search',
    name: 'erpSearch',
    meta: { tag: '订单搜索' },
    component: () => import(`@/pages/PmpRecordPage/erp-search`)
  },
  {
    path: '/pmp-record/:id/send',
    name: 'pmpRecordSendPage',
    meta: { tag: '返修记录发货' },
    component: () => import('@/pages/PmpRecordPage/send')
  },
  {
    path: '/pmp-record-material',
    name: 'pmpRecordMaterialPage',
    meta: { tag: '返修记录物料使用' },
    component: () => import('@/pages/PmpRecordMaterialPage')
  },
  {
    path: '/order-record-material',
    name: 'orderRecordMaterialPage',
    meta: { tag: '订单记录物料使用' },
    component: () => import('@/pages/OrderRecordMaterialPage')
  },
  {
    path: '/expressInLogs',
    name: 'expressInLogs',
    meta: { tag: '收货快递记录' },
    component: () => import('@/pages/expressInLog/ExpressInLogs')
  },
  {
    path: '/expressOutLogs',
    name: 'expressOutLogs',
    meta: { tag: '电商送货单信息' },
    component: () => import('@/pages/ExpressOutLogsPage')
  },
  {
    path: '/expressOutLogs2',
    name: 'expressOutLogs2',
    meta: { tag: '经销商送货单信息' },
    component: () => import('@/pages/ExpressOutLogs2Page')
  },
  {
    path: '/nfc-format-history',
    name: 'nfcFormatHistoryPage',
    meta: { tag: 'NFC格式化记录' },
    component: () => import('@/pages/NfcFormatHistoryPage')
  },
  {
    path: '/wait-confirm-compensation',
    name: 'waitConfirmCompensationPage',
    meta: { tag: '待确认运费补偿工单' },
    component: () => import('@/pages/WaitConfirmCompensationPage')
  },
  {
    path: '/alone-compensation',
    name: 'aloneCompensationPage',
    meta: { tag: '支出记录' },
    component: () => import(`@/pages/AloneCompensationPage`)
  },
  {
    path: '/rma-record',
    name: 'rmaRecordPage',
    meta: { tag: 'RMA工单' },
    component: () => import('@/pages/RmaRecord/index')
  },
  {
    path: '/customer-service',
    name: 'pmpRecordCustomerServicePage',
    meta: { tag: '客服回访工单' },
    component: () => import('@/pages/PmpRecordCustomerServicePage')
  },
  {
    path: '/bonded-area-retread-record',
    name: 'BondAreaRetreadRecordIndexPage',
    meta: { tag: '翻新工单' },
    component: () => import('@/pages/BondedAreaRetreadRecordPage/index')
  }
]

export default repairRecord
